import React, {Component} from 'react';

import QuestionButton from "./QuestionButton";
import PropTypes from "prop-types";
import PopupTitle from "./PopupTitle";

export default class SectionHeading extends Component {
  static propTypes = {
    questionButton: PropTypes.bool,
    title: PropTypes.string.isRequired,
    icon: PropTypes.string.isRequired,
    className: PropTypes.string,
    style: PropTypes.object,
  };

  static defaultProps = {
    className: '',
    questionButton: true,
    style: {},
  };

  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    return (
      <div className="section-heading-outer" style={this.props.style}>
        <div className={`section-heading ${this.props.className}`}>
          <div className={'section-heading-icon'}>
            <img alt={'section-heading-icon'} src={this.props.icon}/>
          </div>

          {this.props.popupId ?
            <PopupTitle popupId={this.props.popupId} tag={'h4'}/> :
              <h4>
                {
                  this.props.questionButton
                  ? (
                    <QuestionButton
                      popUpTitle={this.props.popUpTitle}
                      popUpDescription={this.props.popUpDescription}
                      >
                      {this.props.title}
                    </QuestionButton>
                  )
                  : this.props.title
                }
              </h4>
            }
          </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/elements/SectionHeading.js